import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { IconButton } from '@zola/zola-ui';

import './InputInlineEdit.less';

class InputInlineEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
    };

    this.wrapperRef = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  submit = () => {
    const {
      handleSubmit,
      meta: { pristine },
    } = this.props;

    if (pristine) return false;

    return handleSubmit();
  };

  handleClickOutside = (e) => {
    const isClickOutside = this.wrapperRef.current && !this.wrapperRef.current.contains(e.target);

    if (isClickOutside) {
      const { isEditing } = this.state;

      if (isEditing) {
        this.toggleEditing();
        this.submit();
      }
    }
  };

  handleKeydown = (e) => {
    const keyCode = e.keyCode || e.which;
    const isOutside = this.wrapperRef.current && !this.wrapperRef.current.contains(e.target);

    if (keyCode === 13 && !isOutside) {
      this.toggleEditing();
      this.submit();
    }
  };

  toggleEditing = () => this.setState(prevState => ({ isEditing: !prevState.isEditing }));

  handleOnBlur = (e) => {
    const { input, onBlur } = this.props;

    if (onBlur) onBlur(e, input.value);

    input.onBlur(e);
    this.toggleEditing();
    this.submit();
  };

  renderIsEditing = () => {
    const {
      input,
      min,
      max,
      disabled,
      placeholder,
      id,
      type,
      autoFocus,
      onKeyDown,
      inputClassName,
      viewValueClassName,
    } = this.props;
    const { isEditing } = this.state;

    if (!isEditing) return null;

    return (
      <input
        {...input}
        className={cx('zola-ui__inputInline', viewValueClassName, inputClassName)}
        type={type}
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        onBlur={this.handleOnBlur}
        onKeyDown={onKeyDown}
        min={min}
        max={max}
        value={input.value}
      />
    );
  };

  renderIsViewing = () => {
    const { input, viewValueClassName } = this.props;
    const { isEditing } = this.state;

    if (isEditing) return null;

    return (
      <div onClick={this.toggleEditing}>
        <div className={cx('zola-ui__inlineEdit--viewValue', viewValueClassName)}>{input.value}</div>
        <IconButton
          iconClassName="zola-ui-icon-pencil"
          onClick={this.toggleEditState}
          className="zola-ui__inlineEdit--icon"
        />
      </div>
    );
  };

  render() {
    return (
      <div ref={this.wrapperRef} className="zola-ui__inlineEdit--container">
        {this.renderIsViewing()}
        {this.renderIsEditing()}
      </div>
    );
  }
}

InputInlineEdit.propTypes = {
  inputClassName: PropTypes.string,
  viewValueClassName: PropTypes.string,
  autoFocus: PropTypes.bool,
  type: PropTypes.string,
  input: PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
};

InputInlineEdit.defaultProps = {
  autoFocus: false,
  type: 'text',
  inputClassName: '',
  input: {},
};

export default InputInlineEdit;



// WEBPACK FOOTER //
// ./src/components/common/zolaUI/InputInlineEdit/InputInlineEdit.jsx